import * as React from "react";

// NPM
import { ReactSketchCanvas } from "react-sketch-canvas";

export interface IPaymentContext {
	cardHolder: string;
	handleCardHolderChange: (val: string) => void;
	canvasRef: React.RefObject<ReactSketchCanvas> | null;
	handleCardFlippedChange: (val: boolean) => void;
	cardFlipped: boolean;
	error: string;
	handleErrorChange: (val: string) => void;
}

export const PaymentContext = React.createContext<IPaymentContext>({
	cardHolder: "",
	handleCardHolderChange: (val: string) => {},
	canvasRef: React.createRef<ReactSketchCanvas>(),
	handleCardFlippedChange: (val: boolean) => {},
	cardFlipped: false,
	error: "",
	handleErrorChange: (val: string) => {},
});

export interface PaymentManagerProps {
	children: React.ReactNode;
}

const PaymentManager: React.FC<PaymentManagerProps> = ({ children }) => {
	// States
	const [cardHolder, setCardHolder] = React.useState<string>("");
	const [cardFlipped, setCardFlipped] = React.useState<boolean>(false);
	const [error, setError] = React.useState<string>("");

	// Ref
	const canvasRef = React.useRef<ReactSketchCanvas>(null);

	// Handlers

	const handleCardHolderChange = (val: string) => {
		setCardHolder(val);
	};

	const handleCardFlippedChange = (val: boolean) => {
		setCardFlipped(val);
	};

	const handleErrorChange = (val: string) => {
		setError(val);
	};

	return (
		<PaymentContext.Provider
			value={{
				cardHolder,
				handleCardHolderChange,
				canvasRef,
				handleCardFlippedChange,
				cardFlipped,
				error,
				handleErrorChange,
			}}
		>
			{children}
		</PaymentContext.Provider>
	);
};

export const usePaymentManager = () => React.useContext(PaymentContext);

export default PaymentManager;
